import assertNever from "assert-never";
import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { ClockInOutCallType, GeoAndAddress } from "../../messages/Visit";
import { STRINGS } from "../../strings";
import { globalize, translate } from "../../translate";
import { AppButton } from "../Generic/AppButton";
import { AppAbstractModal } from "../Generic/AppModal/AppAbstractModal";
import ModalHeadline from "../Generic/AppModal/components/ModalHeadline/ModalHeadline";
import MapWithMarker from "./MapWithMarker";

export interface PromptClockReadyModalProps {
  isOpen: boolean;
  clockType: ClockInOutCallType;
  geoAndAddress: GeoAndAddress;
  onRequestClose: () => void;
  onClickClock: () => void;
}

const PromptClockReadyModal = (props: PromptClockReadyModalProps) => {
  const clockButtonText = (() => {
    switch (props.clockType) {
      case ClockInOutCallType.IN:
        return translate(STRINGS.READY_TO_CLOCK_IN);
      case ClockInOutCallType.OUT:
        return translate(STRINGS.READY_TO_CLOCK_OUT);
      default:
        assertNever(props.clockType);
    }
  })();

  const formattedNow = globalize().formatLocalDateTime(LocalDateTime.now(), {
    datetime: "short",
  });

  return (
    <AppAbstractModal
      className="PromptClockReadyModal"
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    >
      <div className="map-wrapper">
        <MapWithMarker coordinates={props.geoAndAddress.geoLocation} zoom={15} />
      </div>

      <div className="content-wrapper">
        <ModalHeadline>{props.geoAndAddress.address}</ModalHeadline>

        <div className="message">
          <p>{formattedNow}</p>
        </div>

        <div className="actions">
          <AppButton variant="filled" color="primary" onClick={props.onClickClock}>
            {clockButtonText}
          </AppButton>
          <AppButton variant="link" color="black" onClick={props.onRequestClose}>
            {translate(STRINGS.NO_THANKS)}
          </AppButton>
        </div>
      </div>
    </AppAbstractModal>
  );
};

export default PromptClockReadyModal;
